// extracted by mini-css-extract-plugin
export default {"delete-all-checkbox":"styles__delete-all-checkbox--f1DhX"};